<div class="row">

    <div class="col-lg-12">
        <div class="mb-3">
            <label for="unit" class="form-label" i18n="@@Address_Unit">Unit</label>
            <input name="unit" [disabled]="disableInputs" class="form-control" autocomplete="off" type="text"
                [(ngModel)]="addressModel.unit" placeholder="Enter Unit" i18n-placeholder="@@Address_EnterUnit"
                [patterns]="addressPattern" mask='0* 0* 0* 0* 0* 0*' [dropSpecialCharacters]="false" />
        </div>
    </div>
    <div class="col-lg-6 col-xl-4">
        <div class="mb-3">
            <label for="streetNum" class="form-label" i18n="@@">Street Number</label>
            <input required #streetNum="ngModel" [disabled]="disableInputs"
                [ngClass]="{ 'is-invalid': (streetNum.invalid && ((streetNum.dirty || streetNum.touched) || submitted == true))&& includeValidation == true}"
                class="form-control" type="text" [(ngModel)]="addressModel.streetNumber"
                placeholder="Enter Street Number" i18n-placeholder="@@" [patterns]="addressPattern"
                mask='0* 0* 0* 0* 0* 0*' [dropSpecialCharacters]="false" />
            <div *ngIf="streetNum.invalid && ((streetNum.dirty || streetNum.touched) || submitted == true) && includeValidation == true "
                class='invalidInputTextMessage'> <!-- this is the style of form-invalid -->
                <div *ngIf="streetNum.errors?.['required']">
                    <div i18n="@@">Street Number Required</div>
                </div>
            </div>
        </div>

    </div>
    <div class="col-lg-6 col-xl-4">
        <div class="mb-3">
            <label for="address1" class="form-label" i18n="@@Address_Street">Street Name</label>
            <input required #street="ngModel" [disabled]="disableInputs"
                [ngClass]="{ 'is-invalid': (street.invalid && ((street.dirty || street.touched) || submitted == true))&& includeValidation == true}"
                class="form-control" type="text" [(ngModel)]="addressModel.address1" placeholder="Enter Street Name"
                i18n-placeholder="@@Address_EnterStreet" [patterns]="addressPattern" mask='0* 0* 0* 0* 0* 0*'
                [dropSpecialCharacters]="false" />
            <div *ngIf="street.invalid && ((street.dirty || street.touched) || submitted == true) && includeValidation == true "
                class='invalidInputTextMessage'> <!-- this is the style of form-invalid -->
                <div *ngIf="street.errors?.['required']">
                    <div i18n="@@Error_StreetRequired">Street Address Required</div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-6 col-xl-4">
        <div class="mb-3">
            <label for="city" class="form-label" i18n="@@Address_City">City</label>
            <input required #city="ngModel" [disabled]="disableInputs"
                [ngClass]="{ 'is-invalid': (city.invalid && ((city.dirty || city.touched) || submitted == true))&& includeValidation == true}"
                class="form-control" type="text" [(ngModel)]="addressModel.city" placeholder="Enter City"
                i18n-placeholder="@@Address_EnterCity" [patterns]="addressPattern" mask='0* 0* 0* 0* 0* 0*'
                [dropSpecialCharacters]="false" />
            <div *ngIf="city.invalid && ((city.dirty || city.touched) || submitted == true) && includeValidation == true "
                class='invalidInputTextMessage'> <!-- this is the style of form-invalid -->
                <div *ngIf="city.errors?.['required']">
                    <div i18n="@@Error_CityRequired">City Required</div>
                </div>
            </div>
        </div>

    </div>

    <div class="col-lg-6 col-xl-4">
        <div class="mb-3">
            <label for="postalCode" class="form-label" i18n="@@Address_PostalCode">Postal Code</label>
            <input required #postalcode="ngModel" [disabled]="disableInputs"
                [ngClass]="{ 'is-invalid': (postalcode.invalid && ((postalcode.dirty || postalcode.touched) || submitted == true))&& includeValidation == true}"
                class="form-control" type="text" [(ngModel)]="addressModel.postalCode" placeholder="Enter Postal Code"
                i18n-placeholder="@@Address_EnterPostalCode" mask='AAA AAA' [dropSpecialCharacters]="false">
            <div *ngIf="postalcode.invalid && ((postalcode.dirty || postalcode.touched) || submitted == true) && includeValidation == true "
                class='invalidInputTextMessage'> <!-- this is the style of form-invalid -->
                <div *ngIf="postalcode.errors?.['required'] else elsePostalCode">
                    <div i18n="@@Error_PostalCodeRequired">Postal Code Required</div>
                </div>
                <ng-template #elsePostalCode>
                    <div *ngIf="postalcode.invalid">
                        <div i18n="@@Error_PostalCodeInvalid">Postal Code Invalid</div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div *ngIf="addressModel.country != 'USA'" class="col-lg-6 col-xl-4">
        <div class="mb-3">
            <label i18n="@@Address_Province">Province</label>
            <app-ng-select-layout [placeHolderText]="'Select Province'" [invalidText]="'Province Required'" [(model)]="addressModel.province" [items]="provinceList" [includeValidation] = "includeValidation"  [disableInput]="disableInputs"  [submitted]="submitted"  ></app-ng-select-layout>
        </div>
    </div>
    <div *ngIf="addressModel.country == 'USA'" class="col-lg-6 col-xl-4">
        <div class="mb-3">
            <label i18n="@@Address_State">State</label>
            <app-ng-select-layout [placeHolderText]="'Select State'" [invalidText]="'State Required'" [includeValidation] = "includeValidation"  [disableInput]="disableInputs" [submitted]="submitted" [(model)]="addressModel.province" [items]="statesList" ></app-ng-select-layout>
        </div>
    </div>

    <div class="col-lg-6 col-xl-4">
        <div class="mb-3">
            <label i18n="@@Address_Country">Country</label>
            <app-ng-select-layout [placeHolderText]="'Select Country'" [invalidText]="'Country Required'" [(model)]="addressModel.country" [items]="countryList" [includeValidation] = "includeValidation"  [disableInput]="disableInputs" [submitted]="submitted"  ></app-ng-select-layout>
        </div>
    </div>

</div>